import { useForm as useReactHookForm, FieldValues, UseFormProps } from "react-hook-form";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useForm<TFieldValues extends FieldValues = FieldValues, TContext = any>(props: UseFormProps<TFieldValues, TContext> = {}) {

  return useReactHookForm<TFieldValues>({
    ...props,
    mode: "onBlur",
    reValidateMode: "onChange",
    shouldFocusError: true,
  });

}
